import {
  PRACTICEAREAFORM_FETCHITEM_LOAD,
  PRACTICEAREAFORM_FETCHITEM_SUCCEED,
  PRACTICEAREAFORM_FETCHITEM_FAIL,
  PRACTICEAREAFORM_EDITFORM_CHANGE,
  PRACTICEAREAFORM_ENTER_RESET,
  PRACTICEAREAFORM_CREATEITEM_LOAD,
  PRACTICEAREAFORM_CREATEITEM_SUCCEED,
  PRACTICEAREAFORM_CREATEITEM_FAIL,
  PRACTICEAREAFORM_EDITITEM_LOAD,
  PRACTICEAREAFORM_EDITITEM_SUCCEED,
  PRACTICEAREAFORM_EDITITEM_FAIL,
  PRACTICEAREAFORM_DELETEITEM_LOAD,
  PRACTICEAREAFORM_DELETEITEM_SUCCEED,
  PRACTICEAREAFORM_DELETEITEM_FAIL,
} from '../constants/actionTypes'

export default (state = {}, action) => {
  switch (action.type) {
    case PRACTICEAREAFORM_FETCHITEM_LOAD:
      return { ...state, isFetchItemLoading: true, fetchItemError: null }
    case PRACTICEAREAFORM_FETCHITEM_SUCCEED:
      return { ...state, isFetchItemLoading: false, item: action.item }
    case PRACTICEAREAFORM_FETCHITEM_FAIL:
      return { ...state, isFetchItemLoading: false, fetchItemError: action.fetchItemError }
    case PRACTICEAREAFORM_ENTER_RESET:
      return {}
    case PRACTICEAREAFORM_EDITFORM_CHANGE:
      return { ...state, formFieldValues: { ...state.formFieldValues, ...action.field } }
    case PRACTICEAREAFORM_CREATEITEM_LOAD:
      return {
        ...state,
        isCreateItemLoading: true,
        isCreateItemSuccess: false,
        createItemError: null,
      }
    case PRACTICEAREAFORM_CREATEITEM_SUCCEED:
      return { ...state, isCreateItemLoading: false, isCreateItemSuccess: true }
    case PRACTICEAREAFORM_CREATEITEM_FAIL:
      return { ...state, isCreateItemLoading: false, createItemError: action.createItemError }
    case PRACTICEAREAFORM_EDITITEM_LOAD:
      return {
        ...state,
        isEditItemLoading: true,
        isEditItemSuccess: false,
        editItemError: null,
      }
    case PRACTICEAREAFORM_EDITITEM_SUCCEED:
      return { ...state, isEditItemLoading: false, isEditItemSuccess: true }
    case PRACTICEAREAFORM_EDITITEM_FAIL:
      return { ...state, isEditItemLoading: false, editItemError: action.editItemError }
    case PRACTICEAREAFORM_DELETEITEM_LOAD:
      return {
        ...state,
        isDeleteItemLoading: true,
        isDeleteItemSuccess: false,
        deleteItemError: null,
      }
    case PRACTICEAREAFORM_DELETEITEM_SUCCEED:
      return { ...state, isDeleteItemLoading: false, isDeleteItemSuccess: true }
    case PRACTICEAREAFORM_DELETEITEM_FAIL:
      return { ...state, isDeleteItemLoading: false, deleteItemError: action.deleteItemError }
    default:
      return state
  }
}
